import { render, staticRenderFns } from "./casesUser_copy.vue?vue&type=template&id=2badd048&scoped=true"
import script from "./casesUser_copy.vue?vue&type=script&lang=js"
export * from "./casesUser_copy.vue?vue&type=script&lang=js"
import style0 from "./casesUser_copy.vue?vue&type=style&index=0&id=2badd048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2badd048",
  null
  
)

export default component.exports